import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ChatMessage } from './design.models';

export const DesignActions = createActionGroup({
  source: 'Design',
  events: {
    Load: emptyProps(),
    'Set Chat Messages': props<{ messages: ChatMessage[] }>(),
  },
});
